import regeneratorRuntime from "regenerator-runtime";
import Utilitiesjs from '../utilites';
import Dashboardjs from './dashboard';
import Ajaxjs from '../ajax';
import ECommForm from "../ecommForm";
import ECommSession, { ECommStripePaymentProvider } from "../ecomm";

export default class MemberDuesFormJs {

    constructor() {
        this.running = false;
        this.utilsjs = new Utilitiesjs;
        this.ajaxjs = new Ajaxjs;
        this.dashboardjs = new Dashboardjs;
    }

    async init(container$, product) {

        this.container$ = container$;
        this.product = product;

        this.form$ = container$.find("form");
        this.currentYear = this.form$.find('#currentYear').val();

        this.submitButton$ = this.form$.find("[type='submit']");
        this.successMessage$ = container$.find(".success");

        const pp = new ECommStripePaymentProvider({
            paymentProviderReferenceName: ECommSettings.StripePaymentProvider
        });

        this.session = new ECommSession();
        await this.session.initAsync({
            paymentProvider: pp
        });

        this.ecommFields = new ECommForm(container$);
    }

    async paymentSubmit(e) {

        const info = this.ecommFields.getCustomerInfo();
        const session = this.session;
        await session.getCustomer().updateInfo({
            info: info.Info
        });

        let customer = session.getCustomer();
        let customerinfo = await customer.getInfoAsync();
        let order = await customer.newOrderAsync();

        await order.addItemAsync({
            variantID: this.product.VariantID,
            measureID: this.product.MeasureID,
            description: this.product.Title,
            quantity: 1,
            additionalJSON: {
                CurrentYear: this.currentYear
            }
        });

        return await order.checkoutAsync({
            shippingAddress: info.ShippingAddress,
            billingAddress: info.BillingAddress
        });
    }

    async postMemberDuesForm(e, tokenId, successMessageId, failedMessageId, loadingId, inputSectionId, iconClass, successIconUrl) {
        e.preventDefault();
        if (this.submitting) return;
        this.submitting = true;

        var that = this;

        let button = that.utilsjs.disableButton(e);
        that.utilsjs.hideById(failedMessageId);
        that.utilsjs.hideById("failedDuesMessage");
        that.utilsjs.showById(loadingId);
        document.getElementById(tokenId).value = await grecaptcha.execute(SiteSettings.GoogleRecaptchaKey, { action: 'jobPostingFormPage' });

        //Transaction:
        try {

            this.ecommFields.hideError();
            await this.paymentSubmit();
            var paid = '';
            var interval = window.setInterval(async function () {
                paid = await that.ajaxjs.postForm("PaymentRecordComplete", "Member", "");
                if (paid === '200' || paid === '202') {
                    clearInterval(interval);
                    if (paid === '202') {
                        location.reload(); //Reload page when AutoCloseCycle
                    } else {
                        that.utilsjs.hideById(loadingId);
                        that.utilsjs.showInlineById(successMessageId);
                        that.utilsjs.hideById(failedMessageId);
                        that.utilsjs.hideById("customFailedDuesMessage");
                        that.utilsjs.hideById(inputSectionId);
                        //$(`.${iconClass}`).attr('src', successIconUrl);

                        //document.getElementById(iconId).src = successIconUrl;

                        $(".paid-incomplete").hide();
                        $(".paid-complete").show();
                        $(".payment-section").addClass("section-success");
                        $(".payment-section .due-payment-form-block").hide();

                        //$(`.${iconClass}`).attr('src', successIconUrl);
                        $(`.${iconClass}`).removeClass('required-icon');
                        $(`.${iconClass}`).addClass('complete-icon');
                        $('#ItemsRequire').text($('.required-icon').length);
                        that.dashboardjs.checkIfCycleIsComplete();

                        //CUSTOM: check show Declaration
                        cscpjs.default.dashboardjs.declarationCheckShow.Paid = true;
                        cscpjs.default.dashboardjs.declarationShowModule();

                        button.disabled = false;
                        this.submitting = false;
                        window.scrollTo(0, 200);
                    }
                }
            }, 2000);

        } catch (ex) {
            that.utilsjs.hideById(loadingId);
            that.utilsjs.showById(failedMessageId);
            that.utilsjs.showById("customFailedDuesMessage");
            that.utilsjs.hideById(successMessageId);
            button.disabled = false;
            this.submitting = false;

            //CUSTOM: check show Declaration
            cscpjs.default.dashboardjs.declarationCheckShow.Paid = false;
            cscpjs.default.dashboardjs.declarationShowModule();
        }

    }

    async acceptGracePeriod(e, successMessageId, failedMessageId, loadingId, inputSectionId, iconId, successIconUrl) {

        e.preventDefault();
        if (this.submitting) return;
        this.submitting = true;

        var that = this;

        let button = that.utilsjs.disableButton(e);
        that.utilsjs.hideById(failedMessageId);
        that.utilsjs.hideById("failedDuesMessage");
        that.utilsjs.showById(loadingId);

        if (await this.ajaxjs.postForm("AcceptGracePeriod", "Member", "") === '200') {

            that.utilsjs.hideById(loadingId);
            that.utilsjs.showInlineById(successMessageId);
            that.utilsjs.hideById(failedMessageId);
            that.utilsjs.hideById("failedDuesMessage");
            that.utilsjs.hideById(inputSectionId);
            document.getElementById(iconId).src = successIconUrl;

            $(".paid-incomplete").hide();
            $(".paid-complete").show();

            //CUSTOM: check show Declaration
            cscpjs.default.dashboardjs.declarationCheckShow.Paid = true;
            cscpjs.default.dashboardjs.declarationShowModule();

            this.dashboardjs.checkIfCycleIsComplete();

        } else {
            that.utilsjs.hideById(loadingId);
            that.utilsjs.showById(failedMessageId);
            that.utilsjs.showById("failedDuesMessage");
            that.utilsjs.hideById(successMessageId);
        }


        button.disabled = false;
        this.submitting = false;
    }
}


// WEBPACK FOOTER //
// ./Scripts/es6/controllers/memberdues.js